import { lazy, Suspense } from 'react'
import { useAppStore } from '@/store/use-app-store'

const BookingModal = lazy(() =>
  import('./booking-modal').then((m) => ({ default: m.BookingModal })),
)

export function BookingModalHost() {
  const showModal = useAppStore((s) => s.bookingState.showModal)

  if (!showModal) return null

  return (
    <Suspense fallback={null}>
      <BookingModal />
    </Suspense>
  )
}
